module.exports = __webpack_public_path__ + "static/media/slots.f2449424.JPG";